// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_eFb","cls2":"SimplePaperPodcast-cls2_9ck SimplePaperPodcast-cls1_eFb"};